import styled from 'styled-components';
export var OrderConfirmIframe = styled.iframe.withConfig({
  componentId: "sc-132w9yl-0"
})(["border:none;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/order-confirmation/dist/esm/components/OrderConfirmationIframe/styled.js
// module id = 4197
// module chunks = 11